import React from 'react';
import { cn } from '@/utils';

const wordmarkSrc = `${process.env.PUBLIC_URL ?? ''}/brand/akini-logo-landscape.png`;

/** Wordmark image (Akini). Kept path `RapidaText.tsx` for minimal import churn. */
export function RapidaTextIcon(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  const { className, alt = 'Akini Voice', ...rest } = props;
  return (
    <img
      src={wordmarkSrc}
      alt={alt}
      className={cn(
        'h-6 w-auto max-w-[160px] object-contain object-left',
        className,
      )}
      {...rest}
    />
  );
}
